import './node_modules/.pnpm/core-js@3.39.0/node_modules/core-js/modules/es.array.push.mjs';
import './node_modules/.pnpm/core-js@3.39.0/node_modules/core-js/modules/es.iterator.constructor.mjs';
import './node_modules/.pnpm/core-js@3.39.0/node_modules/core-js/modules/es.iterator.for-each.mjs';
import { useEffect } from 'react';

const disableBodyScroll = () => {
  const body = document.body;
  const {
    top,
    overflow,
    width,
    position
  } = body.style;
  const scrollTop = window.scrollY || document.documentElement?.scrollTop || body.scrollTop || 0;
  window.__pie_useBodyScrollLock?.push({
    scrollTop,
    style: {
      top,
      overflow,
      width,
      position
    }
  });
  window.scrollTo(0, 0);
  body.style.top = `-${scrollTop}px`;
  body.style.overflow = 'hidden';
  body.style.width = '100%';
  body.style.position = 'fixed';
};
const enableBodyScroll = function () {
  let restoreScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  const state = window.__pie_useBodyScrollLock?.pop();
  if (state && window.__pie_useBodyScrollLock?.length === 0) {
    Object.entries(state.style).forEach(_ref => {
      let [key, value] = _ref;
      return document.body.style.setProperty(key, value);
    });
    restoreScroll && window.scrollTo(0, state.scrollTop || 0);
  }
};

/**
 * @see https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
 * @description overflow의 hidden 속성과 position의 fixed 속성을 활용해서 body 스크롤 방지하기
 * @note scroll 위치값을 조정하여 scroll을 방지하기 때문에, 화면 깜빡임이 발생할 수 있습니다.
 * @see https://oss.fin.navercorp.com/common-fe/pie/issues/2149
 */
function useBodyScrollLock() {
  let isLock = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  let restoreScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  useEffect(() => {
    if (typeof window.__pie_useBodyScrollLock === 'undefined') {
      window.__pie_useBodyScrollLock = [];
    }
    if (isLock) {
      disableBodyScroll();
    }
    return () => {
      if (isLock) {
        enableBodyScroll(restoreScroll);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLock]);
}

export { useBodyScrollLock as default };
